<template lang="pug">
form.section.content.has-text-centered(v-on:submit.prevent="submit")
  .columns
    .column
    .column
      .field
        div.is-size-3 Create Account
      .field
        div Already have an account? #[router-link(to="/log-in") Log in]
      .field
        .control.is-expanded
          input.input(autocomplete="name" placeholder="Your name" ref="focus" v-bind:class="[$v.name.$error ? 'is-danger' : 'is-success']" v-model.trim="$v.name.$model")
        .help.is-danger(v-show="$v.name.$error && !$v.name.required") Your name is required.
        .help.is-danger(v-show="$v.name.$error && !$v.name.valid") Your name is invalid.
      .field
        .control.is-expanded
          input.input(autocomplete="email" placeholder="Your email" type="email" v-bind:class="[$v.email.$error ? 'is-danger' : 'is-success']" v-model.trim="$v.email.$model")
        .help.is-danger(v-show="$v.email.$error && !$v.email.email") Your email is invalid.
        .help.is-danger(v-show="$v.email.$error && !$v.email.required") Your email is required.
      .field
        .control.is-expanded
          input.input(autocomplete="phone" placeholder="Your phone number" v-bind:class="[$v.phone.$error ? 'is-danger' : 'is-success']" v-model.trim="$v.phone.$model")
        .help.is-danger(v-show="$v.phone.$error && !$v.phone.validPhone") Your phone number is invalid.
      .field
        .control.is-expanded
          input.input(autocomplete="current-password" placeholder="Your password" type="password" v-bind:class="[$v.password.$error ? 'is-danger' : 'is-success']" v-model.trim="$v.password.$model")
        .help.is-danger(v-show="$v.password.$error && !$v.password.minLength") Your password is too short.
        .help.is-danger(v-show="$v.password.$error && !$v.password.required") Your password is required.
      .field
        .control.is-expanded
          .select.is-fullwidth(v-bind:class="[$v.operator.$error ? 'is-danger' : 'is-success']")
            select(v-model.number="$v.operator.$model")
              option(value="0") Please select an operator
              option(v-bind:value="operator.id" v-for="operator in operators") {{ operator.name }}
        .help.is-danger(v-show="$v.operator.$error && !$v.operator.minValue") Please select an operator.
        .help.is-danger(v-show="$v.operator.$error && !$v.operator.required") Operator is required.
      .field.margin-top-40
        .control
          .buttons.is-centered
            button.button.is-primary(type="submit" v-bind:disabled="$v.$invalid") Create Account
      .field.margin-top-40
        span By clicking Sign Up, you accept our <a href="/privacy-policy" rel="noopener noreferrer" target="_blank">privacy policy</a> and <a href="/terms" rel="noopener noreferrer" target="_blank">terms and conditions</a>.
    .column
</template>

<script>
import { email, helpers, minLength, minValue, required } from 'vuelidate/lib/validators'
import { parsePhoneNumberFromString } from 'libphonenumber-js/max'

import ApiMixin from '@/mixins/ApiMixin.vue'
import DeviceMixin from '@/mixins/DeviceMixin.vue'

const valid = helpers.regex('invalid', /^.+ .+$/)

export default {
  mixins: [
    ApiMixin,
    DeviceMixin
  ],
  data () {
    return {
      email: null,
      name: null,
      password: null,
      operator: null,
      operators: [],
      phone: null
    }
  },
  mounted () {
    this.deviceSetFocus()
    this.initialiseOperators()
    this.initialiseOperator()
  },
  methods: {
    initialiseOperator () {
      this.operator = this.operators.length === 1 ? this.operators[0].id : 0
    },
    initialiseOperators () {
      this.operators = this.apiOperators.filter((operator) => operator.canSignUp)
    },
    async submit () {
      await this.apiSignUp(this.email, this.name, this.operator, this.password, this.phone)
    }
  },
  validations () {
    return {
      email: {
        email,
        required
      },
      name: {
        required,
        valid
      },
      operator: {
        minValue: minValue(1),
        required
      },
      password: {
        minLength: minLength(8),
        required
      },
      phone: {
        async validPhone (string) {
          if (string) {
            const phoneNumber = await parsePhoneNumberFromString(string, 'GB')
            return phoneNumber && phoneNumber.isValid() && ['GG', 'JE', 'GB'].includes(phoneNumber.country)
          } else {
            return true
          }
        }
      }
    }
  }
}
</script>
